import React, { useEffect, useState } from 'react';
import { initializeIcons } from '@fluentui/react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import './App.css';
import './assets/frappe-gantt.css';
import { IWithErrorHandlingProps } from './components/withErrorHandling';
import { IDataServices } from './types';
import { AppGlobals } from './AppGlobals';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { MsSignIn } from './MsSignIn';
import { AfterSignIn } from './AfterSignIn';
import { ZedXMainApp } from './ZedXMainApp';
import { CustomSignIn } from './CustomSignIn';
import { ManageProjectsAppWithErrorHandling } from './ManageProjectsApp';
import { TrackRisksAppWithErrorHandling } from './TrackRisksApp';
import { AccountAdminAppWithErrorHandling } from './AccountAdminApp';
import { ProgresUpdatesAppWithErrorHandling } from './ProgresUpdatesApp';
import { ButtonCommandBarExample } from './test/ButtonCommandBarExample';
import { CommandBarBasicExample } from './test/CommandBarBasicExample';
import MobileDetector from './test/MobileDetector';
import MobileDetector2 from './test/MobileDetector2';
import MobileDetectorUsingHook from './test/MobileDetectorUsingHook';
import { CorporateWorkflowsAppWithErrorHandling } from './CorporateWorkflowsApp';
import { GIAAActionsAppWithErrorHandling } from './GIAAActionsApp';
import BlobFileDownloadTest from './test/BlobFileDownloadTest';
import FileUploadTest from './test/FileUploadTest';
import { NAOTrackerAppWithErrorHandling } from './NAOTrackerApp';
import { CLAppWithErrorHandling } from './CLApp';
import { GoAppWithErrorHandling } from './GoApp';
import { IAPAppWithErrorHandling } from './IAPApp';
import { CAAppWithErrorHandling } from './CAApp';
import axios from 'axios';
import { KnowledgeHubAppWithErrorHandling } from './KnowledgeHubApp';
import { GroupNotificationsAppWithErrorHandling } from './GroupNotificationsApp';
import { VerticalBarChartTooltipExample } from './test/VerticalBarChartTooltipExample';
import ScreenSizeDetectorUsingHook from './test/ScreenSizeDetectorUsingHook';
import { DonutChartBasicExample } from './test/DonutChartBasicExample';
import { DonutChartDynamicExample } from './test/DonutChartDynamicExample';
import { VerticalStackedBarChartTooltipExample } from './test/VerticalStackedBarChartTooltipExample';
import { ContentStyleProvider } from './components/ContentStyleContext';
import { StudyPlannerAppWithErrorHandling } from './StudyPlannerApp';
import { HeatMapChartBasicExample } from './test/HeatMapChartBasicExample';
import { RiskHeatMapExample1 } from './test/RiskHeatMapExample1';
import { RiskHeatMapExample2 } from './test/RiskHeatMapExample2';
import { RiskHeatMapExample3 } from './test/RiskHeatMapExample3';
import { AgileWorkStreamsAppWithErrorHandling } from './AgileWorkStreamsApp';
import { FrappeGanttTest } from './test/FrappeGanttTest';
import FrappeGanttTestResponsive from './test/FrappeGanttTestResponsive';
import MyMouseTrackerTest from './test/MyMouseTrackerTest';
import MyMouseTracker2Test from './test/MyMouseTracker2Test';
import DndTest1 from './test/DndTest1';
import DnDTest2 from './test/DnDTest2';
import DndTestBoards1 from './test/DndTestBoards1';
import DndTestBoards2 from './test/DndTestBoards2';
import DndTestBoards3 from './test/DndTestBoards3';
import DndTestBoards4 from './test/DndTestBoards4';
import DndTestBoards5 from './test/DndTestBoards5';
import DndTestBoards6 from './test/DndTestBoards6';
import DndTestBoards7 from './test/DndTestBoards7';
import DndTestBoards8 from './test/DndTestBoards8';
import { DndTestBoards9 } from './test/DndTestBoards9';
import SvarGanttExample1 from './test/SvarGanttExample1';
import SvarGanttZoomExample1 from './test/SvarGanttZoomExample1';
import SvarGanttZoomExample2 from './test/SvarGanttZoomExample2';
import SvarGanttProjectsExample from './test/SvarGanttProjectsExample';
import SvarGanttProjectsExampleDefaultTypes from './test/SvarGanttProjectsExampleDefaultTypes';
import { SvarGanttIssueTest } from './test/SvarGanttIssueTest';
import { CloeAIAppWithErrorHandling } from './CloeAIApp';


initializeIcons();
Intl.DateTimeFormat().resolvedOptions().timeZone = 'UTC'; // Set timezone


export interface IOrbProps extends IWithErrorHandlingProps {
  dataServices: IDataServices;
  authType: string;
  menuData?: any[];
  onLogout?: () => void;
}

const App: React.FunctionComponent<IOrbProps> = (props: IOrbProps) => {

  const [userLoggedInAndSelected, setUserLoggedInAndSelected] = useState<boolean>(false);
  const { instance } = useMsal();
  const [appsMenuData, SetAppsMenuData] = useState([]);

  useEffect(() => {
    document.title = `ZedX for ${AppGlobals.CustomerSectorTitle}`;
  }, []);

  useEffect(() => {
    SetAppsMenuData(props.menuData);
  }, [props.menuData]);

  const handleAccountSelection = () => {
    //console.log('in handleAccountSelection', AppGlobals.Username);
    //console.log('customer id', AppGlobals.CustomerID);
    setUserLoggedInAndSelected(true);
  };

  const handleLogout = () => {
    //console.log('in handleLogout');
    if (AppGlobals.AuthType === "CustomJwt") {
      AppGlobals.UserID = null;
      AppGlobals.Username = null;
      AppGlobals.UserTitle = null;
      AppGlobals.CustomJwtToken = null;
      AppGlobals.CustomerID = null;
      AppGlobals.CustomerTitle = null;
      window.location.href = AppGlobals.ZedxNetSiteUrl;
    }
    else {
      //AzureAd Logout
      sessionStorage.clear();
      instance.logoutRedirect({
        postLogoutRedirectUri: "/"
      });

    }
    setUserLoggedInAndSelected(false);
  };

  const { authType } = props;
  //console.log('authType', authType);

  const renderApps = (
    <HashRouter>
      <Switch>
        <Route
          exact
          path={["/", "/account/:any*"]} // Specify multiple paths
          render={({ match }) => {
            return (
              <ZedXMainApp
                authType={authType}
                onLogout={handleLogout}
                menuData={appsMenuData}
                {...props}
              />
            );
          }}
        />
        <Route
          path="/progress-updates/:any*"
          render={({ match }) => {
            return <ProgresUpdatesAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />;
          }}
        />
        <Route
          path="/a2/:any*"
          render={({ match }) => {
            return (
              <ContentStyleProvider> {/* Wrap the whole app in the provider */}
                <ManageProjectsAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />
              </ContentStyleProvider>
            );
            //return <ManageProjectsAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />;
          }}
        />
        <Route
          path="/a1/:any*"
          render={({ match }) => {
            return <CorporateWorkflowsAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />;
          }}
        />

        <Route
          path="/a10/:any*"
          render={({ match }) => {
            return <AgileWorkStreamsAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />;
          }}
        />

        <Route
          path="/a13/:any*"
          render={({ match }) => {
            return <StudyPlannerAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />;
          }}
        />
        <Route
          path="/a4/:any*"
          render={({ match }) => {
            return (
              // <GIAAActionsAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />
              <ContentStyleProvider> {/* Wrap the whole app in the provider */}
                <GIAAActionsAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />
              </ContentStyleProvider>
            );
          }}
        />
        <Route
          path="/a5/:any*"
          render={({ match }) => {
            return <NAOTrackerAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />;
          }}
        />
        <Route
          path="/a6/:any*"
          render={({ match }) => {
            return <CLAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />;
          }}
        />
        <Route
          path="/a8/:any*"
          render={({ match }) => {
            return <IAPAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />;
          }}
        />
        <Route
          path="/a7/:any*"
          render={({ match }) => {
            return <GoAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />;
          }}
        />
        <Route
          path="/a9/:any*"
          render={({ match }) => {
            return (
              <ContentStyleProvider> {/* Wrap the whole app in the provider */}
                <CAAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />
              </ContentStyleProvider>
            );
          }}
        />
        <Route
          path="/a3/:any*"
          render={({ match }) => {
            return (
              <ContentStyleProvider> {/* Wrap the whole app in the provider */}
                <TrackRisksAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />
              </ContentStyleProvider>
            );
          }}
        />
        <Route
          path="/a14/:any*"
          render={({ match }) => {
            return (
              <ContentStyleProvider> {/* Wrap the whole app in the provider */}
                <CloeAIAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />
              </ContentStyleProvider>
            );
          }}
        />
        <Route
          path="/a11/:any*"
          render={({ match }) => {
            return <KnowledgeHubAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />;
          }}
        />
        <Route
          path="/a12/:any*"
          render={({ match }) => {
            return <GroupNotificationsAppWithErrorHandling onLogout={handleLogout} menuData={appsMenuData} {...props} />;
          }}
        />
        <Route
          path="/admin/:any*"
          render={({ match }) => {
            return <AccountAdminAppWithErrorHandling onLogout={handleLogout} {...props} />;
          }}
        />
      </Switch>
    </HashRouter>
  );

  // const renderAppTest = (
  //   <VerticalBarChartTooltipExample
  //     authType={authType}
  //     onLogout={handleLogout}
  //     {...props} />
  // );
  const renderAppTest = (
    <SvarGanttIssueTest />
  );

  if (authType === 'CustomJwt') {
    return (
      <React.Fragment>
        {userLoggedInAndSelected ? (
          renderApps
        ) : (
          <CustomSignIn
            onAccountSelection={handleAccountSelection}
            demoEmail={AppGlobals.DemoUserEmail}
          />
        )}
      </React.Fragment>
    );
  }
  else {
    //Auth type is AzureAd
    return (
      <React.Fragment>
        <UnauthenticatedTemplate>
          <MsSignIn />
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
          {userLoggedInAndSelected ? (
            renderApps
          ) : (
            <AfterSignIn
              accountService={props.dataServices.accountService}
              onAccountSelection={handleAccountSelection}
            />
          )}
        </AuthenticatedTemplate>
      </React.Fragment>
    );
  }
};
export default App;